import {MapIcon, MapItem} from "./CmdCenterMapCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";
import {CmdCenterEditAreaModel} from "../../models/cmd/CmdCenterEditAreaModel";
import {NotificationService} from "../../services/NotificationService";
import {LatLngZoom, MapDefaults} from "../../libs/LeafletHelper";
import L from "leaflet";

export class CmdCenterEditAreaCtrl {
    map: any;
    public static $inject = ["$scope", "$state", "$stateParams", "leafletMapEvents", "leafletData", "leafletBoundsHelpers",
        "leafletMarkerEvents", "CmdCenterEditAreaModel", "NotificationService"];
    defaults: MapDefaults = new MapDefaults(false, L.CRS.Simple, 5, -5);
    center: LatLngZoom = new LatLngZoom(0, 0, 0);
    imageLayer: any = null;
    layers:any = [];
    //areaSelect:any = null;
    b64Object: any;
    markers: any;
    geo1Marker: MapItem;
    geo2Marker: MapItem;

    constructor(public $scope:any, public stateService: StateService, public stateParamsService: StateParams, public leafletMapEvents: any,
                public leafletData: any, public leafletBoundsHelpers: any, public leafletMarkerEvents: any, public model: CmdCenterEditAreaModel,
                public notifyService: NotificationService) {
        $scope.vm = this;
        this.geo1Marker = new MapGeoItem(1, 0, 0, "red");
        this.geo2Marker = new MapGeoItem(1, 100, 100, "blue");
        this.markers = [this.geo1Marker, this.geo2Marker];
        var id = stateParamsService["id"];
        var mapSiteId = stateParamsService["mapSiteID"];
        /*
        $scope.$on('leafletDirectiveMap.editAreaMap.click', (beep)=>{
            console.log("got click");
        });
        $scope.$on('leafletDirectiveMap.editAreaMap.areaselect:change', (evt)=>{
            evt.currentScope.vm.calculatePPM();
        });
        */
        $scope.$watch(() => this.model.width, (newVal:any, oldVal:any) => {
            if (newVal != oldVal)
                this.calculatePPM();
        });
        $scope.$watch(() => this.model.height, (newVal:any, oldVal:any) => {
            if (newVal != oldVal)
                this.calculatePPM();
        });
        $scope.$watch(() => this.center.zoom, (newVal:any, oldVal:any) => {
            console.log("zoom=" + newVal);
            if (newVal != oldVal)
                this.calculatePPM();
        });
        $scope.$watch(() => this.geo1Marker, (newVal:any, oldVal:any) => {
            console.log("geo1Marker=" + this.geo1Marker.lat + "," + this.geo1Marker.lng);
            if (newVal != oldVal) {
                this.model.mapArea.geo1PixelsY = this.geo1Marker.lat;
                this.model.mapArea.geo1PixelsX = this.geo1Marker.lng;
            }
        }, true);
        $scope.$watch(() => this.geo2Marker, (newVal:any, oldVal:any) => {
            console.log("geo2Marker=" + this.geo2Marker.lat + "," + this.geo2Marker.lng);
            if (newVal != oldVal) {
                this.model.mapArea.geo2PixelsY = this.geo2Marker.lat;
                this.model.mapArea.geo2PixelsX = this.geo2Marker.lng;
            }
        }, true);
        this.model.init(mapSiteId, id).then((ok) => {
            //console.log("model.init");
            return leafletData.getMap("editAreaMap");
        })
            .then((map) => {
                //console.log("got map");
                this.map = map;
                //var drawnItems = $scope.controls.draw.edit.featureGroup;
                L.control.mousePosition().addTo(map);
                //this.areaSelect = L.areaSelect({width:200,height:300}).addTo(this.map);
                if (id != null) {
                    this.model.getMapAreaImage().then((data) => {
                        if (this.model.mapArea.geo1PixelsY != null)
                            this.geo1Marker.lat = this.model.mapArea.geo1PixelsY;
                        if (this.model.mapArea.geo1PixelsX != null)
                            this.geo1Marker.lng = this.model.mapArea.geo1PixelsX;
                        if (this.model.mapArea.geo2PixelsY != null)
                            this.geo2Marker.lat = this.model.mapArea.geo2PixelsY;
                        if (this.model.mapArea.geo2PixelsX != null)
                            this.geo2Marker.lng = this.model.mapArea.geo2PixelsX;
                        //this.geo1Marker = new MapGeoItem(1,this.model.mapArea.geo1PixelsY,this.model.mapArea.geo1PixelsX, "red");
                        //this.geo2Marker = new MapGeoItem(2,this.model.mapArea.geo2PixelsY,this.model.mapArea.geo2PixelsX, "blue");
                        this.setImage(id, data, this.model.imageWidth, this.model.imageHeight);
                    }).catch((exc) => {
                        this.notifyService.notifyError("Unable to retrieve MapArea image:" + exc);
                    });
                }
                this.calculatePPM();
            });
        this.$scope.$watch(() => this.b64Object, (newValue: any, oldValue: any) => {
            if (newValue != oldValue) {
                var b64Val = newValue.base64;
                //try upload of base64 data to filedata
                this.model.uploadImage(b64Val).then((data) => {
                    this.setImage(this.model.mapArea.fileDataID, b64Val, this.model.imageWidth, this.model.imageHeight);
                    this.calculatePPM();
                });

            }
        });
        $scope.$on('leafletDirectiveMarker.editAreaMap.dragend', (e: any, args: any) => {
            if (args.modelName == "0") {
                this.geo1Marker.lat = args.model.lat;
                this.geo1Marker.lng = args.model.lng;
            }
            else {
                this.geo2Marker.lat = args.model.lat;
                this.geo2Marker.lng = args.model.lng;
            }
        });
    }

    calculatePPM() {
        //if(this.areaSelect == null)
        //    return;
        //var latLng = this.areaSelect.getBounds();
        //var brY = latLng._northEast.lat;
        //var brX = latLng._northEast.lng;
        //var tlY = latLng._southWest.lat;
        //var tlX = latLng._southWest.lng;
        //console.log("got areaselect change tl("+tlX+","+tlY+"). br("+brX+","+brY+")");
        if (parseInt(this.model.width) != NaN && parseInt(this.model.width) > 9) {
            var ppm = Math.abs(this.model.imageWidth) / this.model.width;
            this.model.mapArea.pixelsPerMeter = ppm;
        } else if (parseInt(this.model.height) != NaN && parseInt(this.model.height) > 9) {
            var ppm = Math.abs(this.model.imageHeight) / this.model.height;
            this.model.mapArea.pixelsPerMeter = ppm;
        }
    }

    setImage(id: number, b64: string, width: number, height: number) {
        if (this.imageLayer != null) {
            this.map.removeLayer(this.imageLayer);
        }
        var imgUrl = "data:image/png;base64," + b64;
        this.imageLayer = L.imageOverlay(imgUrl, [[0, 0], [-1 * height, width]]).addTo(this.map);
        this.calculatePPM();
        //this.imageLayer = L.imageOverlay(this.model.getBaseUrl()+"/getImage?id="+id, [[0,0],[-1*height,width]]).addTo(this.map);
    }

    save() {
        this.model.save().then(success => {
            var uuuuu = 3;
            if (success)
                this.stateService.go("cmdcenter.sitearea", {"mapAreaId": this.model.mapArea.id});
        })
    }

    cancel() {
        this.stateService.go("cmdcenter.sitearea", {
            "mapAreaId": this.model.mapArea.id,
            "mapSiteId": this.model.mapSiteId
        });
    }

    export() {
        this.model.export();
    }
}

export class MapGeoItem implements MapItem {
    lat: number;
    lng: number;
    id: number;
    message: string;
    draggable: boolean = true;
    zIndexOffset: number = 2000;
    icon: MapIcon = new MapIcon();
    scope: any;
    focus: boolean = false;
    selected: boolean = false;

    constructor(id: number, lat: number, lng: number, color: string) {
        this.id = id;
        this.message = "drag me around where you want the latitude/longitude to translate to on the map.";
        this.lat = lat;
        this.lng = lng;
        this.icon.icon = "star";
        this.icon.markerColor = color;
    }

    mapCoorOk() {
        if (this.lat == null || this.lng == null)
            return false;
        else
            return true;
    }
}
